import { render, staticRenderFns } from "./Feedbackpage.vue?vue&type=template&id=29c6133c&scoped=true"
import script from "./Feedbackpage.vue?vue&type=script&lang=js"
export * from "./Feedbackpage.vue?vue&type=script&lang=js"
import style0 from "./Feedbackpage.vue?vue&type=style&index=0&id=29c6133c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c6133c",
  null
  
)

export default component.exports